import { useEffect } from 'react'
import SimilarHomes from '../SimilarHomes'
import { ListingDetailsListing, SearchListing } from '../../../../types/listings'
import { DesktopListingDetailsImage } from './DesktopListingDetailsImage'
import { DesktopListingDetailsFooter } from './DesktopListingDetailsFooter'
import { DesktopListingDetailsSidebar } from './DesktopListingDetailsSidebar'
import { DesktopListingDetailsMainPanel } from './DesktopListingDetailsMainPanel'
import { ChromeExtensionPromptCard } from '../ChromeExtensionPromptCard/Desktop/ChromeExtensionPromptCard'

import styles from './DesktopListingDetails.module.scss'

export interface DesktopListingDetailsProps {
  listing: ListingDetailsListing
  similarListings: SearchListing[]
}

export const DesktopListingDetails = ({
  listing,
  similarListings,
}: DesktopListingDetailsProps) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    })
  }, [])

  return (
    <>
      <DesktopListingDetailsImage listing={listing} />
      <div className={styles.body}>
        <div className={styles.splitPaneContainer}>
          <DesktopListingDetailsMainPanel listing={listing} />
          <DesktopListingDetailsSidebar listing={listing} />
        </div>
        {similarListings.length > 0 && (
          <SimilarHomes
            listings={similarListings}
            className={styles.section}
            isSlim
          />
        )}
        <ChromeExtensionPromptCard className={styles.section} />
        <DesktopListingDetailsFooter listing={listing} />
      </div>
    </>
  )
}
